export enum FileErrorCode {
    PDP_PAGE = 101,
    ORDER_SUMMARY_PAGE = 201,
    CART_PAGE = 301,
    CART_SUMMARY_WRAPPER = 401,
    ADDRESS = 501,
}